<template>
  <p
    v-if="!bankSelect"
    class="my-3 mx-1 has-text-grey has-text-size-14"
  >
    <template v-if="!isBusiness">
      {{ $t("bnpl:psd2.select_bank.description") }}
    </template>
    <template v-else>
      {{ $t("b2b:psd2.select_bank.description") }}
    </template>
  </p>
  <div
    v-if="loadingBankGuides && bankSelect"
    class="flex-column align-items-center"
  >
    <div class="mx-6 mt-6 mb-4">
      <IllustrationsSpinnerCircle />
    </div>
    <p class="has-text-align-center has-text-size-16 has-text-light-grey mx-10 no-mobile-margin">
      {{ $t("bnpl:psd2.select_bank.loading.description") }}
    </p>
  </div>
  <div
    v-if="!loadingBankGuides && bankSelect && bankGuides.length > 0"
    class="flex-column mt-4 gap-18"
  >
    <h4 class="h bold">
      {{ $t("bnpl:psd2.bank_tips.title") }}
    </h4>
    <div
      v-for="(bankGuide, i) in bankGuides"
      class="bank-guide-box"
    >
      <div
        class="bank-guide-box-image"
        :style="{
          backgroundImage: `url(${bankGuide.image})`,
        }"
      />
      <div class="bank-guide-box-content">
        <p class="bold has-text-size-14">
          {{ bankGuide.title }}
        </p>
        <p class="has-text-grey">
          {{ bankGuide.description }}
        </p>
        <button
          id="bnpl_psd2_toggle_bank_guide_popup_button"
          class="linkButton"
          @click="toggleBankGuidePopup(i)"
        >
          {{ $t("bnpl:psd2.button.details") }}
          <font-awesome-icon :icon="['fas', 'arrow-right']" />
        </button>
        <Popup
          v-if="showBankGuidePopup[i]"
          :title="bankGuide.title"
          :ok-button-text="$t('bnpl:psd2.popup.button.ok')"
          @close="toggleBankGuidePopup(i)"
        >
          <div class="popup-content-wrapper flex-column">
            <figure>
              <img :src="bankGuide.image">
            </figure>
            <div
              class="dynamic-content-style has-text-size-14"
              v-html="bankGuide.content"
            />
          </div>
        </Popup>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCountryStore } from '~~/stores/country';
import { usePsd2FlowStore } from '~~/stores/psd2Flow';

const countryStore = useCountryStore();
const psd2FlowStore = usePsd2FlowStore();

const loadingBankGuides = ref(true);
const showBankGuidePopup = ref([]);

const bankGuides = computed(() => psd2FlowStore.bankGuides);

const props = defineProps({
  bankSelect: {},
  isBusiness: {
    type: Boolean,
    default: false,
  }
});

function toggleBankGuidePopup(index) {
  showBankGuidePopup.value[index] = !showBankGuidePopup.value[index];
}

watch(() => props.bankSelect, async (value) => {
  loadingBankGuides.value = true;
  await psd2FlowStore.fetchBankGuidesByBankId(countryStore.locale.slice(0, 2), props.bankSelect, props.isBusiness);
  loadingBankGuides.value = false;
});
</script>

<style scoped lang="scss">
.popup-content-wrapper {
  max-width: 572px;

  figure {
    margin: 16px 0 16px 0;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  button.btn {
    width: 100% !important;
  }
}

.linkButton {
  font-size: 12px;
  color: var(--brandPrimary);
}

.linkButton.has-text-size-14 {
  font-size: 14px;
  color: var(--brandPrimary);
}

.bank-guide-box {
  padding: 16px;
  background: white;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  gap: 16px;

  .bank-guide-box-image {
    flex: 1;
    border-radius: 8px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .bank-guide-box-content {
    flex: 2;
    display: flex;
    flex-direction: column;
    gap: 8px;

    button {
      width: fit-content;
      margin-top: 8px;
    }
  }
}

@media only screen and (max-width: 792px) {
  .bank-guide-box {
    flex-direction: column;

    .bank-guide-box-image {
      flex: none;
      height: 120px;
    }
  }

  // Was inherited from PSD2.vue's unscoped block, which no longer leaks.
  .no-mobile-margin {
    margin: 0;
  }
}
</style>